<template>
  <div id="app">
    <app-header />
    <main class="main-content">
      <router-view />
    </main>
    <app-footer />
    <floating-sidebar />
    <requirement-dialog />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import FloatingSidebar from '@/components/layout/FloatingSidebar.vue'
import RequirementDialog from '@/components/common/RequirementDialog.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    FloatingSidebar,
    RequirementDialog
  },
  mounted() {
    this.$store.dispatch('loadNavigation')
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: $header-height;

  @media (max-width: 768px) {
    padding-top: $header-height-mobile;
  }
}
</style>
